<div class="container">
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <a (click)="redirect()">Go to Home Page</a>
  </div>
  